import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';
import { Box, Grid, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAppDispatch } from '../../redux/hooks';
import { clearClientSecret } from '../../redux/subscription/subscriptionSlice';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!, {});

function Checkout({
  clientSecret,
  showBackButton = false,
}: {
  clientSecret: string;
  showBackButton?: boolean;
}) {
  const dispatch = useAppDispatch();
  const handleClose = () => {
    dispatch(clearClientSecret());
  };
  return (
    <Grid display="flex" flexDirection="column" gap={4}>
      <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }} i18nIsDynamicList>
        {showBackButton && (
          <Box style={{ position: 'relative' }}>
            <IconButton
              onClick={() => handleClose()}
              style={{
                position: 'absolute',
                right: 0,
                bottom: 1,
                zIndex: 10,
              }}
            >
              <CloseIcon sx={{ width: '25px', height: '25px' }} />
            </IconButton>
          </Box>
        )}
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </Grid>
  );
}

export default Checkout;
